import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Ghanaian Ghana Card generator following Single Responsibility Principle
 */
export class GhGenerator extends BaseGenerator {
  generate() {
    // Generate 9 digits for the main part
    const digits = this.randomDigits(9);
    
    // Calculate Luhn check digit
    let sum = 0;
    let alternate = false;

    for (let i = digits.length - 1; i >= 0; i--) {
      let n = parseInt(digits[i]);
      
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      
      sum += n;
      alternate = !alternate;
    }

    const checkDigit = (10 - (sum % 10)) % 10;
    return `GHA-${digits}-${checkDigit}`;
  }
}